import { Component } from '@angular/core';
import { AuthService } from '../../../../services/auth.service';
import { NeighborhoodService } from '../../../../services/neighborhood.service';

@Component({
  selector: 'app-settings-payments-page',
  templateUrl: './settings-payments-page.component.html',
  styleUrl: './settings-payments-page.component.scss'
})
export class SettingsPaymentsPageComponent {

  constructor(
    public authService: AuthService,
    public neighborhoodService: NeighborhoodService,
  ) {}

  update() {
    if (!this.neighborhoodService.currentNeighborhood!.autoCharging) {
      this.neighborhoodService.currentNeighborhood!.autoInactivateHouses = false;
    }
    this.neighborhoodService.update();
  }

}
